
import { Component, Prop, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../../../../framework/state';
import { getResource, getResourcesNew, putResource } from '../../../../../../framework/client/resource';
import TextField from '../../../../../../framework/fields/TextField.vue';
import SelectField from '../../../../../../framework/fields/SelectField.vue';
import { PurchaseInvoiceRow } from '../../../../../../../common/application/model/PurchaseInvoiceRow';
import SwitchField from '../../../../../../framework/fields/SwitchField.vue';
import IntegerField from '../../../../../../framework/fields/IntegerField.vue';
import CurrencyAmountField from '../../../../../../framework/fields/CurrencyAmountField.vue';
import NumberField from '../../../../../../framework/fields/NumberField.vue';
import PercentageField from '../../../../../../framework/fields/PercentageField.vue';
import DateField from '../../../../../../framework/fields/DateField.vue';
import { ValidationObserver } from 'vee-validate';
import TextAreaField from '../../../../../../framework/fields/TextAreaField.vue';
import VendorContractSelect from '../../../../../fields/VendorContractSelect.vue';
import { PurchaseInvoice } from '../../../../../../../common/application/model/PurchaseInvoice';
import { ApplicationResource } from '../../../../../../../common/application/enumeration/ApplicationResource';
import AutoCompleteField from '../../../../../../framework/fields/AutoCompleteField.vue';

@Component({
    components: {
        VendorContractSelect,
        TextAreaField,
        DateField,
        PercentageField,
        NumberField,
        CurrencyAmountField,
        SelectField,
        TextField,
        SwitchField,
        IntegerField,
        ValidationObserver,
        AutoCompleteField,
    },
})
export default class ChangePurchaseInvoiceRowPeriods extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.PURCHASE_INVOICE_ROW;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        purchaseInvoice: {} as PurchaseInvoice,
        startDate: undefined as Date | undefined,
        endDate: undefined as Date | undefined,
        loading: false,
    };

    // Functions
    async mounted() {
        this.local.purchaseInvoice = (await getResource<PurchaseInvoice>(
            ApplicationResource.PURCHASE_INVOICE,
            this.id,
        ))!!;
    }

    async save() {
        const parameters = new Map<string, string>();
        parameters.set('purchaseInvoiceId', this.id);
        parameters.set('pageSize', '10000');
        const rows = (await getResourcesNew<PurchaseInvoiceRow>(this.resourceType, -1, parameters))!!;

        this.local.loading = true;

        for (const row of rows) {
            await putResource<PurchaseInvoiceRow>(this.resourceType, row.id, {
                ...row,
                startDate: this.local.startDate!!,
                endDate: this.local.endDate!!,
            });
        }

        this.local.loading = false;

        this.back();
    }

    back() {
        this.$router.go(-1);
    }
}
